// extracted by mini-css-extract-plugin
module.exports = {"image_row":"Image_Title_Row_image_row__1ebZo","title_row":"Image_Title_Row_title_row__1DiNn","padding":"Image_Title_Row_padding__2sEAl"};